import { render } from "./ItemPanel.vue?vue&type=template&id=69671789"
import script from "./ItemPanel.vue?vue&type=script&lang=js"
export * from "./ItemPanel.vue?vue&type=script&lang=js"

import "./ItemPanel.vue?vue&type=style&index=0&id=69671789&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__